import React from 'react'
import "../../CSS/Blog/Matrix.css"
import FooTer from "../footer"
import MatrixScreen from "../../Images/Blog/matrix_plot.png"
import MatrixZip from "../../Projects/Blog/Matrix.zip"

export default function MatrixWebsite() {
    return (
        <>
            <h1 id="start">Creating A Responsive Matrix Website!</h1>
            <hr />
            <h1 className="hd">In This Video Creating A Matrix WebPage with HTML, CSS, JS</h1>
            <div className="phishing-yt">
                <iframe id="yt" src="https://www.youtube.com/embed/JrkM8kSMn-Y" title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>
            </div>
            <div className="yt-visit">
                <p id="sub">
                    If You Guys Injoy My Video So Visit My Youtube Channel:
                </p>
                <a id="cd" rel="noreferrer" href="https://www.youtube.com/channel/UClkomV-p7Ul_d4-Ye5uOvYg" target="_blank"><button>Code
                    Arindam</button></a>
            </div>
            <p className="ans">
                In This Video Using: <br />
                <br />
                1) HTML<br />
                2) CSS<br />
                3) JAVASCRIPT (JS)<br />
            </p>
            <div className="mat">
                <p>How Matrix Screen Looks Like...</p>
                <img src={MatrixScreen} id="matrix" alt="loading" />
            </div>
            <p className="q">
                Suprise Your Friends!
            </p>
            <p className="ans">
                So about fun  there's lot about previous video u can show like a hackers screen look that's a lot of fun with that website.
            </p>
            <p className="q">
                In This Video We Using...
            </p>
            <p className="ans">
                Matrix screen is a black and green codes just float in up-down and looks so much hacking like that's about tollywood movie 'MATRIX'.
            </p>
            <p className="q">
                :: DOWNLOAD THE FULL ZIP FILE OF Matrix Site ::
            </p>
            <div className="zip-downloader">
                <button id="zip"><a href={MatrixZip}>DOWNLOAD</a></button>
            </div>
            <p className="last">
                So Hope You Guys Injoy This Video And So Be Carefull And Stay Helthy And Have A Great Day...
            </p>
            <FooTer />
        </>
    )
}
